import { Outlet } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'
import type { AllFeatureIds } from 'generated/featureIds.generated'
import { ProfessionalsPayrollDashboardPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isFeatureAvailabilityEnabled } from 'modules/core/lib/isFeatureAvailabilityEnabled'

import { PayrollResultFilterProvider } from 'modules/bookkeepers/hooks/PayrollResultContext'
import { useClientsContext } from 'modules/bookkeepers/hooks/useClientsContext'
import { PayrollStatus } from 'modules/payroll_bundle/lib/enums'

const factorialProfessionalsFeatureId: AllFeatureIds = 'factorial_professionals'
const inhousePayrollFeatureId: AllFeatureIds = 'inhouse_payroll'

const PayrollDashboard = () => {
  const { selectedCompanyId } = useClientsContext()
  const bookkeeperContext = {
    isBookkeeperView: true,
  }
  const { data, loading } = useQuery(ProfessionalsPayrollDashboardPageDocument, {
    variables: {
      companyId: Number(selectedCompanyId),
      featureAvailabilityIds: [Features.compensations_management],
      featureIds: [factorialProfessionalsFeatureId, inhousePayrollFeatureId],
    },
    skip: !selectedCompanyId,
    context: bookkeeperContext,
  })

  const featureAvailabilities = data?.companies.featureAvailabilitiesConnection.nodes || []
  const hasCompensations = isFeatureAvailabilityEnabled(
    featureAvailabilities,
    Features.compensations_management
  )

  if (loading)
    return (
      <Box padding="s40" width="full" alignItems="center">
        <Spinner />
      </Box>
    )

  return (
    <AuthorizeUser authorizeFn={() => !hasCompensations}>
      <PayrollResultFilterProvider defaultValues={{ status: PayrollStatus.PAYROLL_CALCULATION }}>
        <Box>
          <Outlet context={{ selectedCompanyId }} />
        </Box>
      </PayrollResultFilterProvider>
    </AuthorizeUser>
  )
}

export default PayrollDashboard
